import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useSeenPathMutation } from '@/services';

const SEEN_DEBOUNCE_MS = 500;

/**
 * Arriving on a page is itself a "seen" signal for whatever notifications point here. Fires on
 * mount and again on every path change, debounced so a quick chain of navigations only reports
 * the page the visitor actually settles on.
 */
export function useSeenPath(): void {
  const { pathname } = useLocation();
  const { mutate: seenPath } = useSeenPathMutation();

  useEffect(() => {
    const timer = setTimeout(() => seenPath(pathname), SEEN_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [pathname, seenPath]);
}
